import * as React from "react";
import { ModelUser } from "@dia-ui/util_interlink-api";
import {useContext} from "react";
import {AppContext} from "../../context/AppContext";

interface UserFormProps {
  user: ModelUser | undefined;
}

/**
 * read-only view of the signed-in user's own profile. the data is maintained
 * elsewhere, so it renders as plain label-value pairs instead of disabled
 * inputs that look like an editable form
 */
const UserForm: React.FC<UserFormProps> = ({ user }) => {
  const { I18N } = useContext(AppContext);

  /**
   * salutationName
   */
  const salutationName = (salutation: string): string => {
    switch (salutation) {
      case "male": return I18N.t("Herr");
      case "female": return I18N.t("Frau");
      case "divers": return I18N.t("Divers");
      default: return salutation || "";
    }
  };

  /**
   * fact
   * one label-value pair; an empty value renders as an em dash so the reader
   * sees "no value" instead of a hole
   */
  const fact = (label: string, value: string | undefined) => (
    <div data-fact>
      <span data-fact-label>{ label }</span>
      <span data-fact-value>{ value || "—" }</span>
    </div>
  );

  return (
    <div data-fact-sheet>
      { fact(I18N.t("Anrede"), salutationName(user?.salutation || "")) }
      { fact(I18N.t("Vorname"), user?.firstname) }
      { fact(I18N.t("Nachname"), user?.lastname) }
      { fact(I18N.t("Position"), user?.position) }
      { fact(I18N.t("Abteilung"), user?.department) }
      { fact(I18N.t("E-Mail"), user?.email) }
      { fact(I18N.t("Telefon"), user?.fon) }
      { fact(I18N.t("Mobil"), user?.mobil) }
      { fact(I18N.t("LinkedIn"), user?.linkedin) }
    </div>
  );
};

export default UserForm;
